// removed by extract-text-webpack-plugin
module.exports = {"navigation":"theme--navigation--36vhj8Ie","logo":"theme--logo--1zXoOKoc","create":"theme--create--1DB3byD8","links":"theme--links--2GQuhEr2","link":"theme--link--3XAczl3m","isActiveLink":"theme--isActiveLink--Y2-YN_4Q","partnerWrapper":"theme--partnerWrapper--14JqgNmM","partnerLink":"theme--partnerLink--3fZeY43t","dropdownIcon":"theme--dropdownIcon--2Ee3VhNr","partnerDropdown":"theme--partnerDropdown--mztf8TKX","partnerItem":"theme--partnerItem--13klfc6u"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/Navigation/theme.scss
// module id = 1189
// module chunks = 0